import * as React from "react";
const SvgSearchW = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={13}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M12.146 12.854a.5.5 0 0 0 .708-.708l-.354.354zm-6.313-1.687v-.5A4.833 4.833 0 0 1 1 5.833H0a5.833 5.833 0 0 0 5.833 5.834zm5.334-5.334h-.5a4.833 4.833 0 0 1-4.834 4.834v1a5.833 5.833 0 0 0 5.834-5.834zM5.833.5V1a4.833 4.833 0 0 1 4.834 4.833h1A5.833 5.833 0 0 0 5.833 0zm0 0V0A5.833 5.833 0 0 0 0 5.833h1A4.833 4.833 0 0 1 5.833 1zm6.667 12 .354-.354-2.667-2.666-.354.353-.353.354 2.666 2.667z"
    />
  </svg>
);
export default SvgSearchW;
